import moment from 'moment';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog, hideDesc }) => {
  const [readMore, setReadMore] = useState(true);

  return (
    <div className='blog-post'>
      <Link to={`/blog/${blog?._id}`} className='blog-post_thumb'>
        <img src={blog?.files?.[0]?.path} alt='Blog-Image' />
      </Link>
      <div className='blog-post__content'>
        <ul className='blog-post__meta'>
          <li>
            <span>{moment(blog?.createdAt).format('MMMM DD, yyyy')}</span>
          </li>
        </ul>
        <h3 className='blog-post__title'>
          <Link to={`/blog/${blog?._id}`}>{blog?.title}</Link>
        </h3>
        {!hideDesc && (
          <div
            className='desc-content'
            dangerouslySetInnerHTML={{
              __html: blog?.description,
            }}
          />
        )}
        {/* <a
          // href='#'
          onClick={() => setReadMore(!readMore)}
          // className='blog-post__btn btn btn-outline-dark btn-hover-primary rounded-pill'
        >
          <i>Read {readMore ? 'More' : 'Less'}</i>
        </a> */}
      </div>
    </div>
  );
};

export default BlogCard;
